/** Default toast auto-dismiss duration (ms). Used by the global <ToastContainer>
 *  default and by toasts that must re-declare autoClose after a loading state. */
export const TOAST_AUTO_CLOSE_MS = 1500

/** Minimum duration (ms) a loading toast stays visible before transitioning. */
export const TOAST_MIN_LOADING_MS = 250
